import React from 'react';

const muteOptions = [
  { value: '1_hour', label: '1 hour' },
  { value: '8_hours', label: '8 hours' },
  { value: 'until_tomorrow', label: 'Until tomorrow' },
  { value: 'indefinite', label: 'Until I turn them back on' }
];

export function MuteMenu({ isOpen, onClose, onMute, currentMuteStatus }) {
  if (!isOpen) return null;

  return (
    <div className="absolute right-0 top-full mt-2 bg-white rounded-lg shadow-xl border border-gray-200 py-2 w-64 z-50" data-testid="mute-menu">
      <div className="px-4 py-2 border-b border-gray-100">
        <h4 className="font-semibold text-gray-800">
          {currentMuteStatus ? 'Resume notifications' : 'Pause notifications'}
        </h4>
      </div>
      
      {currentMuteStatus ? (
        <button
          onClick={() => { onMute(false, null); onClose(); }}
          className="w-full px-4 py-2 text-left hover:bg-blue-50 text-blue-600"
          data-testid="unmute-btn"
        >
          Resume notifications
        </button>
      ) : (
        <>
          {muteOptions.map((option) => (
            <button
              key={option.value}
              onClick={() => { onMute(true, option.value); onClose(); }}
              className="w-full px-4 py-2 text-left hover:bg-gray-50 text-gray-700"
              data-testid={`mute-${option.value}`}
            >
              {option.label}
            </button>
          ))}
          <div className="px-4 py-2 border-t border-gray-100 mt-2">
            <p className="text-xs text-gray-500">
              Messages will still arrive. You just won't be interrupted.
            </p>
          </div>
        </>
      )}
    </div>
  );
}
